import React, { useEffect } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";

const QuestionsBox = props => {
    const [showQuestion, setShowQuestion] = React.useState(true);
    const [answerText, setAnswerText] = React.useState(props.answer);

    const toggleQuestion = (item) => {
        if (answerText && answerText.length > 0) {
            setShowQuestion(false);
        } else {
            setShowQuestion(item);
        }
    };

    useEffect(() => {
        // console.log("useEffect", props.answer);
        if (props.answer && props.answer.length > 0) {
            setShowQuestion(false);
        } else {
            setShowQuestion(true);
        }
        setAnswerText(props.answer || "");
    }, [props]);

    const popover = (
        <Popover id="popover-basic" className="questions-pop">
            {props.title}
        </Popover>
    );

    return (
        <div className="questions-box-border">
            <div className="questions-box">
                <div className="questions-box-title">
                    {showQuestion
                        ? props.title
                        :
                        <OverlayTrigger trigger={['hover', 'focus', 'click']} placement="left-start" overlay={popover} rootClose>
                            <div className="q-logo">Q</div>
                        </OverlayTrigger>
                    }
                </div>
                <div className="answer-box">
                    <textarea
                        className="answer-box-textarea"
                        placeholder="Write your text here"
                        value={props.answer || ""}
                        onFocus={() => toggleQuestion(false)}
                        onBlur={() => toggleQuestion(true)}
                        onChange={e => props.handleAnswerChange(props.id, e.target.value)}
                    />

                </div>
            </div>
        </div >
    );
};

export default QuestionsBox;